// axios.js

import axios from 'axios';
import { useAuthUserStore } from '@stores/auth';

const instance = axios.create({
  // Bounded default: a stalled API request must fail rather than spin
  // forever. Large uploads bypass axios via XHR presigned PUTs.
  timeout: 60000,
});

instance.interceptors.request.use(async config => {
  // Never send Authorization to presigned storage URLs — it breaks SigV4 and triggers CORS preflight.
  // Match on signature markers / S3 hosts only: the dev API itself sits behind a
  // cloudfront.net distribution, so a blanket cloudfront.net check stripped the
  // Bearer token from every API call (401s while logged in).
  const url = String(config.url || '');
  const lowerUrl = url.toLowerCase();
  const isPresignedS3 =
    lowerUrl.includes('x-amz-signature') ||
    lowerUrl.includes('x-amz-credential') ||
    lowerUrl.includes('key-pair-id=') ||
    lowerUrl.includes('signature=') ||
    /\.s3[.-].*amazonaws\.com/i.test(url);
  if (isPresignedS3) {
    if (config.headers && (config.headers as any).Authorization) delete (config.headers as any).Authorization;
    return config;
  }
  const token = await useAuthUserStore().getCurrentToken(); // Refresh the session
  if (token) {
    config.headers.Authorization = `Bearer ${token}`; // Add token to Authorization header
  }
  return config;
});

export default instance;
